<script setup lang="ts">
const model = defineModel<string>({ default: '' });
</script>

<template>
  <textarea v-model="model" class="textarea" />
</template>
